import React, { useEffect, useRef, useState } from "react";
import LayoutContainer from "../../../components/Containers/LayoutContainer";
import CommonTable from "../../../components/Table/CommonTable";
import { TableColumn } from "../../../components/Table/CommonTable";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { ArrowLeft, TrashFill } from "react-bootstrap-icons";
import ModalWrapper from "../../../components/Modal/ModalWrapper";
import InputField from "../../../components/InputField/InputField";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { ModalRef } from "../../../utils/constants/Interfaces.constants";
import APIList from "../../../utils/constants/APIList";
import { postDetails } from "../../../services/http/http.service";
import setInputValues from "../../../utils/helpers/setInputValue";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store/storeRequests";
import { hideLoader, showLoader } from "../../../store/Loader/loader.slice";
import { hideToast, showToast } from "../../../store/Toast/toast.slice";
import convertTimestamp from "../../../utils/helpers/convertTimeStamp";
import formatDate from "../../../utils/helpers/formatDate";

interface Folder {
  id: number;
  folder_name: string;
  created: Date;
  status: any;
}

// const folders = [
//     {
//         id: 1,
//         folder_name: "Folder 1",
//         created: new Date(),
//         status: 1,
//     },
//     {
//         id: 2,
//         folder_name: "Folder 2",
//         created: new Date(),
//         status: 0,
//     },
//     {
//         id: 3,
//         folder_name: "Folder 3",
//         created: new Date(),
//         status: 0
//     },

// ]

const AddFolder: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const [folders, setFolders] = useState<[]>([]);
  const [addfolders, setAddFolders] = useState<[]>([]);
  const [folderName, setFolderName] = useState("");
  const cmpMounted = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchGetAllFolder();
  }, []);

  const fetchGetAllFolder = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.folder_list, {});
      const modifiedData = response.data.map((item: Folder) => ({
        ...item,
        created: new Date(item.created).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }));
      setFolders(modifiedData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const postFolder = async (ev: any) => {
    ev.preventDefault();
    if (folderName.length === 0) {
      dispatch(showToast("Enter Folder Name"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.add_Folder, {
        folder_name: folderName.trim(),
      });
      //   setAddFolders(response.data || [])
      console.log(response);

      if (response.statusCode === 200) {
        dispatch(showToast("Folder Added Successfully ."));
        setTimeout(() => dispatch(hideToast()), 3000);
        fetchGetAllFolder();
      } else if (response.status === "Failed" || response.Status === "Failed") {
        dispatch(
          showToast(
            response.message || "Some error occurred while adding folder"
          )
        );
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      } else 
      // if (response.statusCode === "10005")
         {
        dispatch(showToast("Some error occurred while adding folder"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
      closeModal();
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(showToast(`Some error occurred while adding folder`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
      setFolderName("");
    }
  };

  const deleteItemById = async (item: Folder) => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.delete_Folder, {
        id: item.id,
      });
      if (response.status === "Failed") {
        dispatch(showToast("Cannot delete Folder"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
      dispatch(showToast("Folder Deleted Successfully ."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchGetAllFolder();
    } catch (error) {
      console.error("Error deleting folder:", error);
      dispatch(
        showToast(
          "An error occurred while trying to delete the folder. Please try again."
        )
      );
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const modalRef = useRef<ModalRef>(null);

  const openAddFolderModal = () => {
    if (modalRef.current) {
      modalRef.current.toggleModalWrapper(true);
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      setFolderName("");
      modalRef.current.toggleModalWrapper(false);
    }
  };

  const columns: TableColumn[] = [
    {
      key: "folder_name",
      label: "Folder Name",
      sortable: true,
      dataType: "string",
      // search:true
    },
    {
      key: "created",
      label: "Created",
      dataType: "string",
      sortable: true,
      // search:true
    },
  ];

  const buttons = [
    {
      label: "Add Folder",
      theme: "warning",
      // icon: <TrashFill />,
      onClick: openAddFolderModal,
    },
    // {
    //     label:"Back To Main List",
    //     theme:"danger",
    //     icon: <ArrowLeft />,
    // }
  ];

  return (
    <LayoutContainer title="living-responsibility">
      <ModalWrapper
        ref={modalRef}
        title="Add Image Folder"
        callback={() => setFolderName("")}
      >
        <form onSubmit={postFolder}>
          <div className="height-50px mb-5">
            <label htmlFor="Add_Folder" className="font-12 weight-600">
              Folder Name <span className="text-danger">*</span>
            </label>
            <InputField
              // label="Folder Name"
              type="text"
              name="Add_Folder"
              id="Add_Folder"
              value={folderName}
              minLength={3}
              required={true}
              maxLength={50}
              placeholder={"Enter Folder Name..!"}
              onChangeInput={(ev) => {
                setInputValues(ev, folderName, setFolderName);
              }}
            />
          </div>
          <div className="my-2 mx-auto" style={{ width: "10rem" }}>
            <div className="d-flex align-items-center justify-content-center">
              <CustomButton theme="yellow" type="submit" size="md">
                Submit
              </CustomButton>
            </div>
          </div>
        </form>
      </ModalWrapper>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Add Folder
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div>
        <CommonTable<Folder>
          data={folders}
          columns={columns}
          // onEdit={editItem}
          onDelete={deleteItemById}
          // onStatusToggle={(item)=> console.log(item)}
          pagination={true}
          rowsPerPage={10}
          actions={{
            view: false,
            edit: false,
            delete: true,
            checkbox: false,
            status: false,
            showModal: false,
          }}
        />
      </div>
    </LayoutContainer>
  );
};

export default AddFolder;
